import { render, staticRenderFns } from "./PPanelPropertiesGroup.vue?vue&type=template&id=a04ced92"
import script from "./PPanelPropertiesGroup.vue?vue&type=script&lang=js"
export * from "./PPanelPropertiesGroup.vue?vue&type=script&lang=js"
import style0 from "./PPanelPropertiesGroup.vue?vue&type=style&index=0&id=a04ced92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports